import React from "react"
import { Control } from "react-hook-form"
import BadgeShapeFields from "./BadgeShapeFields"
import { BadgeElementFormValues } from "../BadgeSidePanelForm"

type Props = {
  control: Control<BadgeElementFormValues>
}

const BadgeRectangleFields = ({ control }: Props) => (
  <BadgeShapeFields control={control} shapeType="rectangle" />
)

export default BadgeRectangleFields
